export class RightActionDictionary
{
	static ACTION_PRODUCT_VIEW: string = 'catalog_product_view';
	static ACTION_PRODUCT_EDIT: string = 'catalog_product_edit';
	static ACTION_PRODUCT_ADD: string = 'catalog_product_add';
}